const ConversationActionTypes = {
    SET_INVITE_CARD_OPEN: 'SET_INVITE_CARD_OPEN',
    SET_JOINING_STATUS: 'SET_JOINING_STATUS',
};
export default ConversationActionTypes;
